import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52b34f4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-block" }
const _hoisted_2 = {
  key: 0,
  class: "home-block_preHeader"
}
const _hoisted_3 = {
  key: 1,
  class: "home-block_header header"
}
const _hoisted_4 = { class: "home-block_row -baseline" }
const _hoisted_5 = { class: "home-block_column" }
const _hoisted_6 = { class: "home-block_row" }
const _hoisted_7 = { class: "header_title" }
const _hoisted_8 = {
  key: 0,
  class: "header_info"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<svg width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-52b34f4c><g clip-path=\"url(#clip0_3538_9765)\" data-v-52b34f4c><path d=\"M10.9999 20.1667C5.93717 20.1667 1.83325 16.0628 1.83325 11C1.83325 5.93729 5.93717 1.83337 10.9999 1.83337C16.0627 1.83337 20.1666 5.93729 20.1666 11C20.1666 16.0628 16.0627 20.1667 10.9999 20.1667ZM10.0833 13.75V15.5834H11.9166V13.75H10.0833ZM11.9166 12.2421C12.6533 12.0201 13.2857 11.5408 13.6987 10.8916C14.1117 10.2424 14.2778 9.46651 14.1668 8.70514C14.0557 7.94376 13.6749 7.24761 13.0936 6.74346C12.5123 6.23931 11.7693 5.9607 10.9999 5.95837C10.2582 5.95832 9.53936 6.21518 8.96564 6.68528C8.39193 7.15539 7.99876 7.8097 7.853 8.53696L9.6515 8.89721C9.70254 8.64185 9.82504 8.40624 10.0048 8.21779C10.1845 8.02934 10.414 7.89579 10.6666 7.83269C10.9193 7.76959 11.1847 7.77952 11.4319 7.86135C11.6791 7.94317 11.898 8.09351 12.0631 8.29488C12.2282 8.49624 12.3327 8.74036 12.3645 8.99881C12.3963 9.25727 12.3541 9.51944 12.2427 9.75483C12.1313 9.99021 11.9554 10.1891 11.7354 10.3284C11.5154 10.4677 11.2603 10.5417 10.9999 10.5417C10.7568 10.5417 10.5236 10.6383 10.3517 10.8102C10.1798 10.9821 10.0833 11.2153 10.0833 11.4584V12.8334H11.9166V12.2421Z\" fill=\"#3C92FE\" data-v-52b34f4c></path></g><defs data-v-52b34f4c><clipPath id=\"clip0_3538_9765\" data-v-52b34f4c><rect width=\"22\" height=\"22\" fill=\"white\" data-v-52b34f4c></rect></clipPath></defs></svg>", 1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "home-block_column navigation" }
const _hoisted_12 = { class: "home-block_row" }
const _hoisted_13 = { class: "home-block_row navigation_btns" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-52b34f4c><g clip-path=\"url(#clip0_3538_9773)\" data-v-52b34f4c><path d=\"M16.172 11H4V13H16.172L10.808 18.364L12.222 19.778L20 12L12.222 4.22205L10.808 5.63605L16.172 11Z\" fill=\"#0E2242\" data-v-52b34f4c></path></g><defs data-v-52b34f4c><clipPath id=\"clip0_3538_9773\" data-v-52b34f4c><rect width=\"24\" height=\"24\" fill=\"white\" data-v-52b34f4c></rect></clipPath></defs></svg>", 1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-52b34f4c><g clip-path=\"url(#clip0_3538_9778)\" data-v-52b34f4c><path d=\"M7.828 11H20V13H7.828L13.192 18.364L11.778 19.778L4 12L11.778 4.22205L13.192 5.63605L7.828 11Z\" fill=\"#0E2242\" data-v-52b34f4c></path></g><defs data-v-52b34f4c><clipPath id=\"clip0_3538_9778\" data-v-52b34f4c><rect width=\"24\" height=\"24\" fill=\"white\" transform=\"matrix(-1 0 0 1 24 0)\" data-v-52b34f4c></rect></clipPath></defs></svg>", 1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  class: "home-block_body",
  ref: "refBody"
}
const _hoisted_19 = { class: "home-block_footer" }
const _hoisted_20 = {
  key: 3,
  class: "g-preloader_wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_preloader = _resolveComponent("as-preloader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "pre-header", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "title", {}, () => [
                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                  ], true)
                ]),
                (_ctx.showInfoBtn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _renderSlot(_ctx.$slots, "info-btn", {}, () => [
                        _createElementVNode("div", {
                          class: "header_info-btn",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click:info')))
                        }, _hoisted_10)
                      ], true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.showAllBtn)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.linkAll ? 'router-link' : 'div'), {
                      key: 0,
                      class: "navigation_all",
                      to: _ctx.linkAll,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlerNav('all')))
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "navigation-text", {}, () => [
                          _createTextVNode(_toDisplayString(_ctx.viewAllText), 1)
                        ], true)
                      ]),
                      _: 3
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['navigation_btn', 'navigation_prev', _ctx.isDisabledPrev ? '-disabled' : '']),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handlerNav('prev')))
                  }, _hoisted_15, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['navigation_btn', 'navigation_next', _ctx.isDisabledNext ? '-disabled' : '']),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handlerNav('next')))
                  }, _hoisted_17, 2)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_18, [
            _renderSlot(_ctx.$slots, "body", {}, undefined, true)
          ], 512),
          _createElementVNode("div", _hoisted_19, [
            _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_as_preloader, { class: "g-preloader" })
        ]))
  ]))
}